var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-5 p-5 shadow content-info",style:(_vm.estilo)},[_c('HyFLoader',{staticClass:"col-12",attrs:{"variant":"inline"}},[(_vm.mensaje)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.mensaje[_vm.$i18n.locale]))]):_vm._e()])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }